import styled from 'styled-components';

/* Tag type and amplitude narrow the set; feature is the actual choice. The
   first two share a row, the choice gets its own, so the hierarchy is visible
   rather than implied by whatever happens to wrap. */
export const Fields = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 18px 24px;
  padding: 8px 0 4px;
`;

export const Field = styled.div`
  display: flex;
  flex-direction: column;
  gap: 7px;
  min-width: 240px;
  flex: ${props => (props.wide ? '1 0 100%' : '1')};
`;

export const FieldLabel = styled.label`
  ${props => props.theme.fonts.tableRow}
  color: ${props => props.theme.colors.greyXD};
`;

/* The derived strings. Get one wrong and the alarm accepts a customer's
   thresholds and never fires, so they are shown at full size rather than as a
   footnote, and before the click rather than after. */
export const Consequence = styled.div`
  margin-top: 26px;
  padding: 20px 24px;
  background-color: ${props => props.theme.colors.greyXXXL};
  border-left: 3px solid ${props => props.theme.colors.green};
`;

export const ConsequenceRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 4px 16px;
  padding: 7px 0;

  & + & {
    border-top: 1px solid ${props => props.theme.colors.greyL};
  }
`;

export const ConsequenceLabel = styled.span`
  ${props => props.theme.fonts.tableRow}
  color: ${props => props.theme.colors.greyXD};
  flex: 0 0 168px;
`;

export const ConsequenceValue = styled.span`
  ${props => props.theme.fonts.tableRow}
  color: ${props => props.theme.colors.greyXXD};
  min-width: 0;
`;

export const Mono = styled.code`
  font-family: "Roboto Mono", "Courier New", monospace;
  font-size: 13px;
  color: ${props => props.theme.colors.greyXXD};
  background: none;
  padding: 0;
  word-break: break-word;
`;

export const Hint = styled.p`
  ${props => props.theme.fonts.tableRow}
  color: ${props => props.theme.colors.greyXD};
  margin: 16px 0 0;
`;

export const Message = styled.p`
  ${props => props.theme.fonts.tableRow}
  color: ${props => props.error
    ? props.theme.colors.error
    : props.theme.colors.greyXD};
  margin: 0;
  flex: 1;
`;

export const Actions = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 14px;
  margin-top: 32px;
`;

export const ConfirmQuestion = styled.p`
  ${props => props.theme.fonts.lightTitle}
  color: ${props => props.theme.colors.greyXXD};
  margin: 4px 0 0;
  line-height: 1.5;
`;

/* This screen has no delete, so the copy says a create cannot be undone here. */
export const ConfirmNote = styled.p`
  ${props => props.theme.fonts.tableRow}
  color: ${props => props.theme.colors.greyXD};
  margin: 18px 0 0;
  line-height: 1.5;
`;

/* Opening this cold shows two empty dropdowns and nothing else. One sentence
   says what a "feature" is here, which is the word a non-specialist stumbles
   on. It goes away once a tag type is chosen and the real content arrives. */
export const Lede = styled.p`
  ${props => props.theme.fonts.tableRow}
  color: ${props => props.theme.colors.greyXD};
  margin: 0 0 4px;
  line-height: 1.55;
  max-width: 64ch;
`;
